import { render, staticRenderFns } from "./LayoutBar.vue?vue&type=template&id=c8e4dcf8&scoped=true"
import script from "./LayoutBar.vue?vue&type=script&lang=js"
export * from "./LayoutBar.vue?vue&type=script&lang=js"
import style0 from "./LayoutBar.vue?vue&type=style&index=0&id=c8e4dcf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e4dcf8",
  null
  
)

export default component.exports